import { Flex, Text, ThemeIcon } from '@mantine/core';
import { IconAlertTriangle, IconHelpOctagon } from '@tabler/icons-react';
import type { ReactNode } from 'react';

interface ModalWarningContentProps {
  message?: ReactNode;
  iconAlign?: 'center' | 'flex-start';
  isErorr?: boolean;
}

export const ModalWarningContent = ({
  message = 'Неактивный рекрутер не имеет доступа к управлению вакансиями',
  iconAlign = 'center',
  isErorr = true,
}: ModalWarningContentProps) => {
  return (
    <Flex gap={16} align={iconAlign} pb={12}>
      {isErorr ? (
        <ThemeIcon miw={48} mih={48} bg='red.0' radius={100}>
          <IconAlertTriangle size={32} color='var(--mantine-color-red-7)' />
        </ThemeIcon>
      ) : (
        <ThemeIcon miw={48} mih={48} bg='yellow.1' radius={100}>
          <IconHelpOctagon size={32} color='var(--mantine-color-yellow-7)' />
        </ThemeIcon>
      )}
      {typeof message === 'string' ? (
        <Text c='primary.7'>{message}</Text>
      ) : (
        message
      )}
    </Flex>
  );
};
